import { component } from 'picoapp'
import $ from 'jquery'

export default component(node => {
    const note = $('[data-note]')
    const label = $('.cart-page__note label')

    label.click(function(e) {
        e.preventDefault()
        note.slideToggle(200)
    })
})